import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBase, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { setLanguage } from '../../i18n';

/**
 * Hebrew/English switch for the pre-dashboard screens.
 *
 * The dashboard has its own toggle in the sidebar, but before signing in there was none — an
 * English-speaking provider landed on a Hebrew-only login page with no way out. Styled after
 * the marketing site's `.lang-toggle` pill, since it sits on the same purple field.
 *
 * `common.language` holds the name of the OTHER language in each dictionary ("English" in
 * he.json, "עברית" in en.json), which is the same convention the sidebar toggle uses.
 */
const LanguageToggle = () => {
  const { t, i18n } = useTranslation();

  return (
    <ButtonBase
      onClick={() => setLanguage(i18n.language === 'he' ? 'en' : 'he')}
      aria-label={t('common.switchLanguage')}
      sx={{
        position: 'absolute',
        top: { xs: 12, sm: 20 },
        right: { xs: 12, sm: 20 },
        zIndex: 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.5,
        py: 0.85,
        borderRadius: '999px',
        color: '#fff',
        backgroundColor: 'rgba(255,255,255,0.14)',
        border: '1px solid rgba(255,255,255,0.22)',
        backdropFilter: 'blur(6px)',
        transition: 'background-color .15s',
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.24)' },
        '&:focus-visible': { outline: '3px solid rgba(255,255,255,0.65)', outlineOffset: 2 },
      }}
    >
      <LanguageIcon sx={{ fontSize: 17, opacity: 0.85 }} />
      <Typography component="span" sx={{ fontSize: '0.8rem', fontWeight: 600, lineHeight: 1 }}>
        {t('common.language')}
      </Typography>
    </ButtonBase>
  );
};

export default LanguageToggle;
